module.exports = __webpack_public_path__ + "img/horizontal_4_7_r_pp2_4.75b2c8b1.png";